module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAqCAMAAADs1AnaAAAAOVBMVEUAAAD///////////////////////////////////////////////////////////////////////8KOjVvAAAAEnRSTlMA3z+f738Qv48fXyBvT6/PLzA50wgsAAAA8ElEQVQ4y+2T2Y7DIAxFWcwSBpLM/f+PnThiGpIaGlXqW88LyLpcL8LqPby/oSF6rfoBJjVmSg6IZSDzTqOiU0fnCC1OqmXBRojJmBLD7vZktnIm+/t4Ylm1Xnz0FjPXCJ28/BZZJuFdO7IoVcAq1w5QnKA5hS1glYBtrfTV6MhAjW1QIgH4bzk/j/doKB/XIosSEI/6qqnQn/2KbL3pkUgnvjigL6obkbaDnO8sWeSvn1Rg6QDHX4S/zBACbonupStcuO5CXDhLh9REadYDZqM+Q8ScVsV4kwNCZxMZ4o52vOzUQlmJ+BLDspvN+dTTH2KPE3GMsokmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/burning/messsage.png
// module id = JW8m
// module chunks = 0